import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getOffers } from '../../actions/offers';
import { SearchBlock } from '../../components/SearchBlock';
import { SearchBlockModal } from '../../components/SearchBlockModal';
import { INITIAL_OFFERS_REQUEST_QUERY } from '../../constants/offers';
import { selectOffers } from '../../selectors/offers';
import { TThunkDispatch } from '../../types/redux';
import { useApplicationContext } from '../ApplicationContext';

export const SearchBlockContainer: React.FC = () => {
  const context = useApplicationContext();
  const dispatch = useDispatch<TThunkDispatch>();
  const offers = useSelector(selectOffers);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [searchText, setSearchText] = React.useState(offers.length > 0 ? INITIAL_OFFERS_REQUEST_QUERY : '');
  const [inputValue, setInputValue] = React.useState<string>('');
  const withTags = context.config.get<boolean>('mobile-mainpage-frontend.withTags');

  const handleSearchButtonClick = React.useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setModalOpen(true);
  }, []);

  const handleSearch = React.useCallback(
    (query: string) => {
      dispatch(getOffers(query));
      setSearchText('');
      setInputValue('');

      setTimeout(() => {
        const element = document.getElementById('offers');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 50);
    },
    [dispatch],
  );

  return (
    <>
      <SearchBlock text={searchText} onSearchClick={handleSearchButtonClick} />
      <SearchBlockModal
        open={isModalOpen}
        inputValue={inputValue}
        setInputValue={setInputValue}
        onClose={() => setModalOpen(false)}
        onSearch={handleSearch}
        withTags={withTags == null ? true : withTags}
      />
    </>
  );
};

SearchBlockContainer.displayName = 'SearchBlockContainer';
